<template>
  <b-row>
      
    <RegionOverview :lgSize="12"></RegionOverview>
    <ChartNormal size="12" offset="0" title="Delivered Per Customer" chart="column" chartType="company" :withDate="true" :withFinancial="false" :isCompanyOverall="true" />
    <ChartNormal size="6" offset="0" title="Active Backlog" chart="column" chartType="backlog" :withDate="false" :withFinancial="false" />
    <ChartNormal size="6" offset="0" title="Delivered Equipment" chart="pie" chartType="Shipped" :withDate="true" :withFinancial="true" />
    <ChartStacked size="6" offset="0" title="Repair Analytics" chartType="repair" :withDate="true" :withFinancial="false"/>
    <ChartStacked size="6" offset="0" title="Historical Data" chartType="historical" :withDate="false" :withFinancial="false"/>

  </b-row>
</template>

<script>
import ChartNormal from "../components/chart/chartNormal";
import ChartStacked from "../components/chart/chartStacked";
import RegionOverview from "../components/RegionOverview";

export default {
  name: "Dashboard",
  components: {
    ChartNormal,
    ChartStacked,
    RegionOverview
  },
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-label {
  color: #00bf8f !important;
  fill: #00bf8f !important;
}
.markan {
  position: relative;
  /*height: 400px;*/
  .map-container {
    height: 100%;
  }
  .btn-map-fullscreen {
    position: absolute;
    right: 10px;
    top: 10px;
    width: 36px;
    height: 36px;
    padding: 0;
    font-size: 36px;
    line-height: 36px;
    text-align: center;
    outline: none;
  }
  &.fullscreen {
    width: 100%;
    height: 100%;
  }
}
.power {
  background-color: #f86c6b !important;
}
</style>


